import { createApi } from '@reduxjs/toolkit/query/react';
import EnhancedBaseQuery from '../../Api/createApiConfig';

const eyetestApi = createApi({
    reducerPath: 'eyetestApi',
    baseQuery: EnhancedBaseQuery,
    endpoints: () => ({}),
});

const injectedEyetestApi = eyetestApi.injectEndpoints({
    endpoints: (builder) => ({
        eyetestList: builder.mutation({
            query: (eyetestListConfig) => ({
                url: '/eyetests/exportEyeTest',
                method: 'POST',
                body: eyetestListConfig,
            }),
        }),
        recentEyetestList: builder.mutation({
            query: (eyetestListConfig) => ({
                url: '/eyetests/newEyeTestSearch',
                method: 'POST',
                body: eyetestListConfig,
            }),
        }),

        testNames: builder.mutation({
            query: () => ({
                url: '/testnames',
                method: 'GET',
            }),
        }),
        eyetestAdd: builder.mutation({
            query: (eyetestAddConfig) => ({
                url: '/eyetests/add',
                method: 'POST',
                body: eyetestAddConfig,
            }),
        }),
        eyetestEdit: builder.mutation({
            query: (eyetestEditConfig) => ({
                url: '/eyetests/modify',
                method: 'POST',
                body: eyetestEditConfig,
            }),
        }),
        eyetestCount: builder.mutation({
            query: (eyetestCountConfig) => ({
                url: '/eyetests/count',
                method: 'POST',
                body: eyetestCountConfig,
            }),
        }),
        upload1: builder.mutation({
            query: (imageConfig) => ({
                url: '/eyetests/image/upload1',
                method: 'POST',
                body: imageConfig,
            }),
        }),
        upload2: builder.mutation({
            query: (imageConfig) => ({
                url: '/eyetests/image/upload2',
                method: 'POST',
                body: imageConfig,
            }),
        }),
        upload3: builder.mutation({
            query: (imageConfig) => ({
                url: '/eyetests/image/upload3',
                method: 'POST',
                body: imageConfig,
            }),
        }),
        eyeTestById: builder.mutation({
            query: (imageConfig) => ({
                url: '/eyetests/searcheyetestnewbyid',
                method: 'POST',
                body: imageConfig,
            }),
        }),
        eyeTestImageById: builder.mutation({
            query: (imageConfig) => ({
                url: '/eyetests/searcheyetestimagenewbyid',
                method: 'POST',
                body: imageConfig,
            }),
        }),
        prescriptionByTestID: builder.mutation({
            query: (prescriptionConfig) => ({
                url: '/eyetests/prescriptionbytestid',
                method: 'POST',
                body: prescriptionConfig,
            }),
        }),
        referralLetterByTestId: builder.mutation({
            query: (referralLetterConfig) => ({
                url: '/eyetests/referralletterbytestid',
                method: 'POST',
                body: referralLetterConfig,
            }),
        }),
        statusChange: builder.mutation({
            query: (statusChangeConfig) => ({
                url: '/eyetests/approve',
                method: 'POST',
                body: statusChangeConfig,
            }),
        }),
        testCountByMonthUear: builder.mutation({
            query: (config) => ({
                url: '/eyetests/YearMonthEyeTestCount',
                method: 'POST',
                body: config,
            }),
        }),
        assignTestToDoc: builder.mutation({
            query: (config) => ({
                url: '/eyetests/assign',
                method: 'POST',
                body: config,
            }),
        }),
        opthAIdetails: builder.mutation({
            query: (opthAIconfig) => ({
                url: `/eyetests/OpthAIdetails?eyetestid=${opthAIconfig}`,
                method: 'POST',
            }),
        }),
        notifyEyeTest: builder.mutation({
            query: (config) => ({
                url: `/eyetests/notify`,
                method: 'POST',
                body: config,
            }),
        }),
        deleteEyeTest: builder.mutation({
            query: (config) => ({
                url: `/eyetest/delete`,
                method: 'POST',
                body: config,
            }),
        }),
        eyeTestExport: builder.mutation({
            query: (config) => ({
                url: `/eyetests/export?${config}`,
                method: 'POST',
            }),
        }),
        allEyeTestExport: builder.mutation({
            query: (config) => ({
                url: `/eyetests/exportalleyetest`,
                method: 'POST',
            }),
        }),
        summaryreportTestId: builder.mutation({
            query: (referralLetterConfig) => ({
                url: '/eyetests/testsummarydownload',
                method: 'POST',
                body: referralLetterConfig,
            }),
        }),
    }),
    overrideExisting: false,
});
export const {
    useEyetestListMutation,
    useAssignTestToDocMutation,
    useAllEyeTestExportMutation,
    useEyeTestExportMutation,
    useTestCountByMonthUearMutation,
    useEyetestEditMutation,
    useEyeTestImageByIdMutation,
    useEyeTestByIdMutation,
    useEyetestAddMutation,
    useEyetestCountMutation,
    useTestNamesMutation,
    useUpload1Mutation,
    useUpload2Mutation,
    useUpload3Mutation,
    usePrescriptionByTestIDMutation,
    useReferralLetterByTestIdMutation,
    useOpthAIdetailsMutation,
    useRecentEyetestListMutation,
    useStatusChangeMutation,
    useNotifyEyeTestMutation,
    useDeleteEyeTestMutation,
    useSummaryreportTestIdMutation,
} = injectedEyetestApi;
export default eyetestApi;
